import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
  initCommonAction,
  initCommonActionResult,
  initCommonClearAction,
  initCommonClearCreate,
  initCommonClearDelete,
  initCommonClearEdit,
  initCommonClearList,
  initCommonCreate,
  initCommonCreateResult,
  initCommonDelete,
  initCommonDeleteResult,
  initCommonEdit,
  initCommonEditResult,
  initCommonGetList,
  initCommonSetListResult,
} from "../highOrderReducers/commonReducer";
import {mapMessageTemplateEntityToIMessageTemplate} from "./messageTemplatesMappers";
import {
  ICreateMessageTemplatePayload,
  IDeleteMessageTemplatePayload,
  IGetMessageTemplateListPayload,
  IMessageTemplatesInitialState,
  ISetCreateMessageTemplateResultPayload,
  ISetDeleteMessageTemplateResultPayload,
  ISetMessageTemplateListResultPayload,
  ISetUpdateMessageTemplateResultPayload,
  IUpdateMessageTemplatePayload
} from "./messageTemplatesReducerTypes";

const messageTemplatesInitialState: IMessageTemplatesInitialState = {
  itemsObject: {
    items: [],
    isLoading: true,
    totalCount: 0,
  },
  create: {
    isLoading: false,
    isSuccess: false,
    errorMessage: '',
  },
  update: {
    isLoading: false,
    isSuccess: false,
    errorMessage: '',
  },
  delete: {
    isLoading: false,
    isSuccess: false,
    errorMessage: '',
  },
}

const messageTemplatesSlice = createSlice({
  name: 'messageTemplates',
  initialState: messageTemplatesInitialState,
  reducers: {
    getMessageTemplateList(state, {payload}: PayloadAction<IGetMessageTemplateListPayload>) {
      initCommonGetList(state, payload)
    },
    clearMessageTemplateList(state) {
      initCommonClearList(state)
    },
    setMessageTemplateListResult(state, {payload}: PayloadAction<ISetMessageTemplateListResultPayload>) {
      initCommonSetListResult(state, payload, mapMessageTemplateEntityToIMessageTemplate)
    },

    createMessageTemplate(state, {payload}: PayloadAction<ICreateMessageTemplatePayload>) {
      initCommonCreate(state, payload);
    },
    clearCreateMessageTemplate(state) {
      initCommonClearCreate(state);
    },
    setCreateMessageTemplateResult(state, {payload}: PayloadAction<ISetCreateMessageTemplateResultPayload>) {
      initCommonCreateResult(state, payload, mapMessageTemplateEntityToIMessageTemplate)
    },

    updateMessageTemplate(state, {payload}: PayloadAction<IUpdateMessageTemplatePayload>) {
      if (state.update) {
        state.update.isLoading = true;
      }
    },
    clearUpdateMessageTemplate(state) {
      if (state.update) {
        state.update.isLoading = false;
        state.update.isSuccess = false;
        state.update.errorMessage = '';
      }
    },
    setUpdateMessageTemplateResult(state, {payload}: PayloadAction<ISetUpdateMessageTemplateResultPayload>) {
      if (state.update) {
        if (state.itemsObject && payload && payload.item) {
          try {
            const mappedItem = mapMessageTemplateEntityToIMessageTemplate(payload.item);
            state.itemsObject.items = state.itemsObject.items.map(item => item.id !== mappedItem.id ? item : mappedItem);
          } catch (e) {
            // Log error if needed
          }
          state.update.isSuccess = true;
          state.update.errorMessage = '';
        } else if (payload.errorMessage && payload.errorMessage !== '') {
          state.update.isSuccess = false;
          state.update.errorMessage = payload.errorMessage;
        }
        state.update.isLoading = false;
      }
    },

    deleteMessageTemplate(state, {payload}: PayloadAction<IDeleteMessageTemplatePayload>) {
      initCommonDelete(state, { itemId: payload.messageTemplateId });
    },
    clearDeleteMessageTemplate(state) {
      initCommonClearDelete(state);
    },
    setDeleteMessageTemplateResult(state, {payload}: PayloadAction<ISetDeleteMessageTemplateResultPayload>) {
      initCommonDeleteResult(state, payload);
    },
  },
});

export const {
  getMessageTemplateList,
  clearMessageTemplateList,
  setMessageTemplateListResult,

  createMessageTemplate,
  clearCreateMessageTemplate,
  setCreateMessageTemplateResult,

  updateMessageTemplate,
  clearUpdateMessageTemplate,
  setUpdateMessageTemplateResult,

  deleteMessageTemplate,
  clearDeleteMessageTemplate,
  setDeleteMessageTemplateResult,
} = messageTemplatesSlice.actions;
export default messageTemplatesSlice.reducer;

